export default __webpack_public_path__ + "static/media/tile_1.de3442ca.png";